import { Backdrop, Box, Button, CircularProgress } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import DeleteIcon from "@mui/icons-material/Delete";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import ViewUser from "./VIewUser";

const StatisticsForAdmin = ({ token }) => {
	const [loading, setLoading] = useState(false);
	const [Statistics, setStatistics] = useState();
	const [open, setOpen] = React.useState(false);
	const [submit, setSubmit] = useState();
	const handleOpen = (view) => {
		setSubmit(view);
		setOpen(true);
	};
	useEffect(() => {
		const fetchData = async () => {
			try {
				const satistic = await axios.get(
					`${process.env.REACT_APP_API_PATH}/Statistics`,
					{
						headers: {
							Authorization: `Bearer ${token}`,
						},
					},
				);
				setStatistics(satistic?.data?.reverse());
			} catch (error) {
				if (error.response.status) {
					Swal.fire({
						icon: "error",
						title: "Oops...",
						text: error.response.data,
					});
				} else {
					console.log(error);
				}
			}
		};

		if (token) {
			fetchData();
		}
	}, [loading, token]);
	const handleDelete = (id) => {
		Swal.fire({
			title: "Are you sure?",
			text: "You won't be able to revert this!",
			icon: "warning",
			showCancelButton: true,
			confirmButtonColor: "#3085d6",
			cancelButtonColor: "#d33",
			confirmButtonText: "Yes, delete it!",
		}).then(async (result) => {
			if (result.isConfirmed) {
				setLoading(true);
				try {
					await axios
						.delete(
							`${process.env.REACT_APP_API_PATH}/deleteStatistics/${id}`,
							{
								headers: {
									Authorization: `Bearer ${token}`,
								},
							},
						)
						.then(function (response) {
							Swal.fire(
								"Deleted!",
								"That Statistics has been deleted.",
								"success",
							);
							setLoading(false);
						});
				} catch (error) {
					if (error.response.status) {
						Swal.fire({
							icon: "error",
							title: "Oops...",
							text: error.response.data,
						});
					} else {
						console.log(error);
					}
				}
			}
		});
	};
	const columns = [
		{
			field: "user",
			headerName: "User",
			minWidth: 200,
			flex: 1,
		},
		{
			field: "qrScanEvents",
			headerName: "QR Scan",
			minWidth: 310,
			filterable: false,
			flex: 1,
			renderCell: (params) => {
				return <>{params.row?.qrScanEvents?.length || 0} Visits</>;
			},
		},

		{
			field: "Action",
			headerName: "Action",
			minWidth: 310,
			filterable: false,
			flex: 1,
			renderCell: (params) => {
				return (
					<>
						<Button
							onClick={() => handleOpen(params.row)}
							className='button border'
							sx={{
								fontWeight: "bold",
								border: "2px solid",
								backgroundColor: "transparent",
								borderRadius: "25px",
								m: 0.5,
							}}
							variant='contained'>
							<RemoveRedEyeIcon />
						</Button>
						<Button
							className='button border'
							onClick={() => handleDelete(params.row?._id)}
							sx={{
								fontWeight: "bold",
								border: "2px solid",
								backgroundColor: "transparent",
								borderRadius: "25px",
								m: 0.5,
							}}
							variant='contained'>
							<DeleteIcon />
						</Button>
					</>
				);
			},
		},
	];

	return (
		<>
			{Statistics && (
				<Box
					sx={{
						width: "100%",
						height: { md: "80vh", xs: "90vh" },
						"& .MuiDataGrid-toolbarContainer .MuiButtonBase-root": {
							border: "1px solid",
							fontSize: "0.75rem",
							padding: "0px 5px",
							textTransform: "capitalize",
						},
						"& .MuiDataGrid-toolbarContainer .MuiSvgIcon-root": {
							fontSize: "1rem",
						},
					}}>
					<DataGrid
						componentsProps={{
							panel: {
								sx: {
									"& .MuiDataGrid-panelContent": {
										maxWidth: "100vw !important",
									},
								},
							},
						}}
						rows={Statistics || []}
						getRowId={(row) => row?._id}
						columns={columns}
						components={{
							Toolbar: GridToolbar,
						}}
						disableSelectionOnClick
					/>
				</Box>
			)}

			<Backdrop
				sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
				open={!Statistics}>
				<CircularProgress color='inherit' />
			</Backdrop>
			{open && <ViewUser open={open} setOpen={setOpen} submit={submit} />}
		</>
	);
};

export default StatisticsForAdmin;
